module.exports = function(app) {
    'use strict';
    app.directive('architectureDiagram', ['services', 'modal',function(services) {
        return {

            restrict: "A",
            replace: false,

            scope: {

            },
            template: require('directives/common/architectureDiagram.html'),
            controller: ['$scope', 'modal',
                function($scope, modal) {
                    $scope.showDependencyDetails = function(dependency) {
                        $scope.components = dependency.components;
                        modal.open({
                            template: require('modals/architectureDependencyDetails.html'),
                            scope: $scope
                        });
                    };
                    $scope.showStepsDetails = function(step) {
                        $scope.step = step;
                        modal.open({
                            template: require('modals/architectureStepsDetails.html'),
                            scope: $scope
                        });
                    };
                }],

            link: function ($scope, element, attrs) {
                $scope.showCalendar = false;
                $scope.allFeatures;

                var handler = function(evt) {
                    if (!$(evt.target).closest(element).length) {
                        $scope.showCalendar = false;
                    }
                };
                $scope.showAllFeatures = function() {
                    services.eprsvc.architecture().submitSearch().then(function (retObj) {
                        $scope.allFeatures = retObj.data.features;
                        for(var index=0; index<$scope.allFeatures.length;index++) {
                            $scope.allFeatures[index].selected = true;
                            $scope.allFeatures[index].showDependencies = false;
                            $scope.allFeatures[index].showSteps = false;
                            $scope.allFeatures[index].showSubMenu = false;
                        }
                    },function(error){

                    });
                };
                $scope.showSubMenu = function(feature) {

                    feature.showSubMenu = !feature.showSubMenu;
                    for(var index=0; index<$scope.allFeatures.length;index++) {
                            if(feature.description !== $scope.allFeatures[index].description) {
                                $scope.allFeatures[index].selected = !feature.showSubMenu;
                            }
                    }
                    if(feature.showSubMenu){
                        feature.showSubMenuDependency = true;
                        feature.showSubMenuSteps = true;
                    }
                    if(feature.showDependencies){
                        feature.showDependencies = false;
                    }
                    if(feature.showSteps){
                        feature.showSteps=false;
                    }
                };
                $scope.showSelectedFeatureDependency = function(feature) {
                    feature.showDependencies = !feature.showDependencies;

                    feature.showSubMenuDependency = feature.showDependencies;
                    if (feature.showSubMenuDependency) {
                        feature.showSubMenuSteps = !feature.showSubMenuDependency;
                    }else{
                        feature.showSubMenuDependency = true;
                        feature.showSubMenuSteps=true;
                    }
                };
                $scope.showSelectedFeatureSteps = function(feature) {
                    feature.showSteps = !feature.showSteps;

                    feature.showSubMenuSteps = feature.showSteps;
                    if (feature.showSubMenuSteps) {
                        feature.showSubMenuDependency = !feature.showSubMenuSteps;
                    }else{
                        feature.showSubMenuDependency = true;
                        feature.showSubMenuSteps=true;
                    }
                };
                $(document).on('click', handler);
                $scope.$on('$destroy', function () {
                    $(document).off('click', handler);
                });
            }
        };
    }]);
};
